<template>
  <div class="task-list">
    <div class="task-header">
      <div>
        <el-button type="primary" size="small" @click="handleMerge">{{$t('assignTaskV2.merge')}}</el-button>
        <el-button size="small" v-if="tableDataInfo.totalRows > 1" @click="handleAgainSplit">{{$t('assignTaskV2.againApart')}}</el-button>
      </div>
      <div class="header-right">
        <div>{{$t('assignTaskV2.shareNumber')}}：<span class="task-num">{{transFileTaskCountNum.allNum || 1}}</span></div>
        <div>{{$t('assignTaskV2.allocated')}}：<span class="assign-num">{{transFileTaskCountNum.allocated || 0}}/{{transFileTaskCountNum.allNum || 1}}</span></div>
      </div>
    </div>
    <div class="task-table">
      <el-table
        border
        :data="taskList"
        height="100%"
        v-loading="loading"
        header-row-class-name="customHeader"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="60"
        >
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.paragraPhrange')"
          align="center"
          min-width="170"
          class-name="sent-range"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">{{row.startRow}}~{{row.endRow}}</template>
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.wordNumber')"
          prop="sourceWordNum"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.accuracyRate')"
          align="center"
          v-if="IS_SCORE"
        >
          <template slot-scope="{ row }">
            <template v-if="['null', 'undefined'].includes(row.taskScore + '')">--</template>
            <template v-else>{{row.taskScore}}%</template>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.assign')"
          align="center"
          class-name="assign"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-tooltip effect="dark"
              :content="$t('assignTaskV2.assignAgain')"
              placement="top"
            >
              <i class="icon-add" @click="handleAssign(row)" v-if="row.userId === 0"></i>
            </el-tooltip>
            <span v-if="row.userId !== 0" @click="handleAssign(row)" class="user-name">{{row.userName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.byTime')"
          align="center"
          width="220"
        >
          <template slot-scope="{ row }">
            <el-date-picker
              :editable="false"
              :clearable="false"
              :disabled="row.finish === 1"
              v-model="row.limitTime"
              :picker-options="pickerOptions"
              @change="timeChange(row)"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              size="mini"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.progress')"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <el-progress :percentage="row.progress || 0"></el-progress>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('assignTaskV2.statuss')"
          align="center"
          :show-overflow-tooltip="true"
          min-width="120"
        >
          <template slot-scope="{ row }">
            <template v-if="row.userId === 0"><span :class="`task-status`"></span>{{$t('assignTaskV2.notAssign')}}</template>
            <template v-else><span :class="`task-status status-${finishFormat(row)}`"></span>{{ statusFormat(row) }}</template>
          </template>
        </el-table-column>
          <el-table-column
            :label="$t('assignTaskV2.operations')"
            align="center"
            width="200"
            class-name="operate"
          >
            <template slot-scope="{ row }">
              <el-tooltip effect="dark"
                :content="$t('assignTaskV2.previsualization')"
                placement="top"
              >
                <i class="icon-preview" @click="handlePreview(row)" ></i>
              </el-tooltip>

              <el-tooltip effect="dark"
                :content="$t('assignTaskV2.distribution')"
                placement="top"
              >
                <i class="icon-assign" @click="handleAssign(row)"></i>
              </el-tooltip>

              <el-tooltip effect="dark"
                :content="$t('assignTaskV2.split')"
                placement="top"
              >
                <i class="icon-split" @click="handleSplit(row)"></i>
              </el-tooltip>

              <el-tooltip effect="dark"
                :content="$t('projectV2.download')"
                placement="top"
              >
                <el-popover
                  trigger="click"
                  placement="bottom"
                  popper-class="task-download"
                  :ref="`popover-${row.id}`"
                  @after-leave="downloadHide"
                  :visible-arrow='false'
                >
                  <el-cascader-panel
                    v-model="downloadStr"
                    :props='props'
                    :options="options"
                    @change='downloadReport($event, row)'
                  >
                  </el-cascader-panel>
                  <i class="icon-export" slot="reference"></i>
                </el-popover>
              </el-tooltip>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div class="task-pagination">
      <el-pagination
        background
        layout="prev, pager, next, sizes"
        :pager-count="5"
        :current-page="query.page"
        :page-size="query.rows"
        :page-sizes="[10, 20, 30, 40]"
        :total="tableDataInfo.totalRows"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <Assign
      ref="assignDialog"
      :selObj="selObj"
      :visible="assignVisible"
      @handleCancel="assignCancel"
      @updateTaskList="updateTaskList"
    >
    </Assign>

    <SplitFile
    ref="splitFile"
      :selObj="selObj"
      :visible="splitVisible"
      @handleCancel="splitCancel"
      @updateTaskList="updateTaskList"
    >
    </SplitFile>

    <Preview
      :visible="previewVisible"
      :previewObj="previewObj"
      :showConfirmButton="showConfirmButton"
      @handleCancel="previewCancel"
      @updateTaskList="updateTaskList"
    >
    </Preview>

    <DelDialog
      :dialogVisible="tipVisible"
      @handleClose="tipCancel"
      @handleConfirm="tipConfirm"
    >
      <template #title>{{tipTitle}}</template>
      {{tipContent}}
      <template #confirm>{{tipOkBtn}}</template>
    </DelDialog>

    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{$t('projectDetailsV2.downloading')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';
import Assign from '@/components/taskDialog/assign';
import Preview from '@/components/taskDialog/preview';
import SplitFile from '@/components/taskDialog/splitFile';

import { apiRoot } from '@/services/ajax';
import {
  mergeTask,
  reSplitTask,
  updateTaskTime,
  downloadAsyncTask,
  queryPageByFileId,
  getDownloadAsyncResult,
  splitTaskPreViewDetail,
  getTransFileTaskCountNum
} from '@/services/assignTaskApi';

export default {
  name: 'TaskList',
  props: {
    taskType: {
      type: Number,
      require: true,
    },
    activeFile: {
      type: Object,
      require: true,
    },
    projectInfo: {
      type: Object,
      require: true,
    },
  },
  components: {
    Assign,
    Preview,
    DelDialog,
    SplitFile
  },
  data () {
    return {
      IS_SCORE: IS_SCORE,
      isDownloadLoading: false,
      options: [
        {label: this.$t('projectV2.original'), value: 'original'},
        {label: this.$t('projectV2.translation'), value: 'translate-translation'},
        {label: this.$t('projectV2.contrast'), value: 'translate-contrast'},
        {label: this.$t('projectV2.xlfreport'), value: 'XLFreport'},
      ],
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      downloadStr: '',
      query: {
        filter: {
          fileId: this.activeFile.id,
          taskType: this.taskType,
        },
        page: 1,
        rows: 10
      },
      taskList: [],
      loading: true,
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < new Date().getTime() - 86400000;
        },
      },
      previewVisible: false,
      previewObj: {},
      showConfirmButton: false,
      assignVisible: false,
      splitVisible: false,

      tipVisible: false,
      tipTitle: '',
      tipContent: '',
      tipOkBtn: '',
      tipType: '',

      selObj: {
        limitTime: '',
        userId: 0,
        selTaskID: 0,
        startRow: 0,
        endRow: 0,
        wordNum: 0,
        fileId: 0,
        fileName: '',
        taskType: this.taskType,
      },
      transFileTaskCountNum: {},
      selTaskList: [],            // 多选勾选的任务
    }
  },
  mounted () {
    // 来自projectDetail
    this.bus.$on('updateFileTask', () => {
      if (JSON.stringify(this.activeFile) === '{}') {
        return;
      }
      this.getTaskList();
    });
  },
  methods: {
    async timeChange (row) {
      if (row.userId !== 0) {
        if (new Date(row.limitTime) < new Date()) {
          this.$message.warning(this.$t('assignTaskV2.deadtimelessLocatime'));
          this.getTaskList();
          return;
        } else if (new Date(row.limitTime) > new Date(this.projectInfo.deliveryTime)) {
          this.$message.warning(this.$t('assignTaskV2.deadlineNoExceedProjectDeadline'));
          this.getTaskList();
          return;
        }
        let { success } = await updateTaskTime({
          id: row.id,
          limitTime: row.limitTime,
          taskId: row.id
        });
        if (success) {
          this.$message.success(this.$t('assignTaskV2.updateSuccess'));
          this.getTaskList();
        }
      }
      // else {
      //   this.getTaskList();
      // }
    },
    finishFormat (row) {
      if (row.finish === 0) { //未开始
        if (new Date() > new Date(row.limitTime)) {
          return 3;
        }
        return 0;
      } else if (row.finish === 2) { //进行中
        if (new Date() > new Date(row.limitTime)) {
          return 3;
        }
        return 2;
      } else if (row.finish === 1) { //已完成
        if (new Date(row.finishTime) > new Date(row.limitTime)) {
          return 4;
        }
        return 1;
      }
    },
    statusFormat(row) {
      if (row.finish === 0) {
        if (new Date() > new Date(row.limitTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.notBegin');
      } else if (row.finish === 2) {
        if (new Date() > new Date(row.limitTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.inProgress');
      } else if (row.finish === 1) {
        if (new Date(row.finishTime) > new Date(row.limitTime)) {
          return this.$t('projectDetailsV2.overdueComplete');
        }
        return this.$t('projectDetailsV2.completed');
      }
    },
    updateTaskList () {
      this.getTaskList();
      this.getTransFileTaskCountNum();
      this.$emit('updateTaskNum');
    },
    // 获取任务列表
    async getTaskList () {
      // this.taskList = [];
      let { list, success, totalRows, totalPage } = await queryPageByFileId(this.query);
      this.loading = false;
      if (!success) { return; }

      if (list.length === 0) {
        list.push({
          userId: 0,
          sourceWordNum: this.activeFile.sourceWordNum,
          startRow: 1,
          endRow: this.activeFile.sentCount,
          progress: 0,
          limitTime: this.projectInfo.deliveryTime + ':00',
        });
        this.tableDataInfo.totalPage = 1;
        this.tableDataInfo.totalRows = 1;
      } else {
        list.forEach(item => {
          item.limitTime += ':00';
        });
        this.tableDataInfo.totalPage = totalPage;
        this.tableDataInfo.totalRows = totalRows;
      }

      // 根据 startRow 字段进行排序
      list.sort((prop => {
        return (a, b) => {
          let v1 = a[prop];
          let v2 = b[prop];
          return v1 - v2;
        }
      })('startRow'));

      this.taskList = list;
    },
    // 预览
    async handlePreview (item) {
      this.previewVisible = true;
      if (this.IS_SCORE) {
        if (item.finish === 1) {
          this.showConfirmButton = true;
        } else {
          this.showConfirmButton = false;
        }
      } else {
        this.showConfirmButton = false;
      }
      let { success, result } = await splitTaskPreViewDetail({
        splitRowsReqVo: {
          end: item.endRow,
          start: item.startRow
        },
        taskId:item.id,
        taskType:item.taskType,
        fileId: this.activeFile.id,
        versionType: this.taskType,
      });
      if (!success) { return; }
      this.previewObj = {
        taskId: item.id,
        taskType: this.taskType,
        sentList: result,
      };
    },
    // 重新拆分
    async againSplit () {
      let self = this;
      let { success } = await reSplitTask({
        fileId: this.activeFile.id,
        taskType: this.taskType,
      });
      self.$message.closeAll();
      if (success) {
        this.$message.success(this.$t('assignTaskV2.againapartSuceess'));
        this.query.page = 1;
        this.getTaskList();
        this.$emit('updateTaskNum');
        this.getTransFileTaskCountNum();
      } else {
        this.$message.warning(this.$t('assignTaskV2.againapartFail'));
      }
    },
    // 合并
    handleMerge () {
      let self = this;
      self.$message.closeAll();
      if (self.selTaskList.length < 2) {
        self.$message.warning(this.$t('assignTaskV2.selecttwoTask'));
        return;
      }
      // 判断是否含有已完成任务，含有不能合并
      let num = 0;
      self.selTaskList.forEach(item => {
        if (item.finish === 1) {
          num++;
        }
      });
      if (num > 0) {
        self.$message.warning(this.$t('assignTaskV2.haveTaskCompletedNoMerge'));
        return;
      }
      num = 0;
      // 含有已分配的合并需要提示
      self.selTaskList.forEach(item => {
        if (item.userId !== 0) {
          num++;
        }
      });
      if (num > 0) {
        this.tipVisible = true;
        this.tipType = 'merge';
        this.tipTitle = this.$t('assignTaskV2.onecontainerTask');
        this.tipContent = this.$t('assignTaskV2.taskConsolidation');
        this.tipOkBtn = this.$t('assignTaskV2.combine');
      } else {
        this.MergeFun();
      }
    },
    // 合并方法
    async MergeFun () {
      let self = this;
      self.$message.closeAll();
      let selTaskIDList = [];
      self.selTaskList.forEach(item => {
        selTaskIDList.push(item.id);
      });
      let { success, errorDesc } = await mergeTask({
        fileId: self.activeFile.id,
        taskIds: selTaskIDList
      });
      if (success) {
        self.$message.success(this.$t('assignTaskV2.combineSuccess'));
        this.query.page = 1;
        this.getTaskList();
        this.$emit('updateTaskNum');
        this.getTransFileTaskCountNum();
      } else {
        self.$message.closeAll();
        self.$message.warning(errorDesc);
      }
    },
    // 预览关闭
    previewCancel () {
      this.previewVisible = false;
    },
    // 分配
    handleAssign (row) {
      let self = this;
      self.$message.closeAll();
      if (this.projectInfo.finish === 1) {
        self.$message.warning(this.$t('assignTaskV2.projectCompletedNoAssign'));
        return;
      }
      // 任务完成不能重新分配
      if (row.finish === 1) {
        self.$message.warning(this.$t('assignTaskV2.taskCompletedNoAssign'));
        return;
      }
      if (new Date(row.limitTime) < new Date()) {
        self.$message.warning(this.$t('assignTaskV2.deadtimelessLocatime'));
        return;
      }
      else if (new Date(row.limitTime) > new Date(this.projectInfo.deliveryTime)) {
        self.$message.warning(this.$t('assignTaskV2.deadlineNoExceedProjectDeadline'));
        return;
      }

      this.selObj.limitTime = row.limitTime;
      this.selObj.userId = row.userId;
      this.selObj.selTaskID = row.id;
      this.selObj.fileId = this.activeFile.id;

      if (row.userId !== 0) {
        this.tipVisible = true;
        if (row.progress === null || row.progress === 0) {
          this.tipTitle = this.$t('assignTaskV2.taskhaveAllocated');
          this.tipContent = this.$t('assignTaskV2.taskagainAllocated');
        } else {
          this.tipTitle = this.$t('assignTaskV2.taskPedding');
          this.tipContent = this.$t('assignTaskV2.tasksplitTask');
        }
        this.tipType = 'assign';
        this.tipOkBtn = this.$t('assignTaskV2.againSplits');
      } else {
        this.$refs.assignDialog.getSelfUserList();
        this.assignVisible = true;
      }
    },
    // 分配关闭
    assignCancel () {
      this.assignVisible = false;
      this.selObj = {
        limitTime: '',
        userId: 0,
        selTaskID: 0,
        startRow: 0,
        endRow: 0,
        wordNum: 0,
        fileId: 0,
        fileName: '',
        taskType: this.taskType,
      };
    },
    // 拆分
    handleSplit (item) {
      // 任务已完成不能拆分
      this.$message.closeAll();
      if (item.finish === 1) {
        // this.$message.warning('任务已完成，不能再拆分！');
        this.$message.warning(this.$t('assignTaskV2.taskcannotApart'));
        return;
      }
      // 句段数小于1不能够拆分
      let num = item.endRow - item.startRow + 1;
      if (num < 2) {
        this.$message.warning(this.$t('assignTaskV2.taskcannotApart'));
        return;
      }

      this.selObj.selTaskID = item.id;
      this.selObj.endRow = item.endRow;
      this.selObj.fileName = this.activeFile.name;
      this.selObj.startRow = item.startRow;
      this.selObj.fileId = this.activeFile.id;
      this.selObj.wordNum = item.sourceWordNum;

      if (item.userId !== 0) {
        this.tipVisible = true;
        this.tipTitle = this.$t('assignTaskV2.allotTasks');
        this.tipContent = this.$t('assignTaskV2.taskAssigned');
        this.tipType = 'split';
        this.tipOkBtn = this.$t('assignTaskV2.separate');
      } else {
        this.splitVisible = true;
      }
      this.$refs.splitFile.handleSplit()
    },
    // 拆分关闭
    splitCancel () {
      this.splitVisible = false;
    },
    // 提示弹窗确定
    tipConfirm () {
      this.tipVisible = false;
      if (this.tipType === 'assign') {
        this.$refs.assignDialog.getSelfUserList();
        this.assignVisible = true;
      } else if (this.tipType === 'split') {
        this.splitVisible = true;
      } else if (this.tipType === 'againSplit') {
        this.againSplit();
      } else if (this.tipType === 'merge') {
        this.MergeFun();
      }
    },
    // 重新拆分
    handleAgainSplit () {
      let self = this;
      self.$message.closeAll();
      // 判断勾选的任务是否含有已完成的，含有则不能重新拆分
      if ((this.transFileTaskCountNum.countFinish || 0) >= 1) {
        this.$message.warning(this.$t('assignTaskV2.haveTaskCompletedNoAgainSplit'));
        return;
      }
      // 项目已完成不能重新拆分
      if (this.projectInfo.finish === 1) {
        this.$message.warning(this.$t('assignTaskV2.projectCompletedNoSplit'));
        return;
      }
      // 判断任务是否分配
      this.tipVisible = true;
      this.tipType = 'againSplit';
      if ((this.transFileTaskCountNum.allocated || 0) >= 1) {
        this.tipTitle = this.$t('assignTaskV2.containerTask');
        this.tipContent = this.$t('assignTaskV2.tasksAllocated');
        this.tipOkBtn = this.$t('assignTaskV2.againSplit');
      } else {
        this.tipTitle = this.$t('common.tips');
        this.tipContent = this.$t('assignTaskV2.isagainSplit');
        this.tipOkBtn = this.$t('common.ok');
      }
    },
    async getTransFileTaskCountNum () {
      let { success, result } = await getTransFileTaskCountNum({
        taskType: this.query.filter.taskType,
        id: this.query.filter.fileId
      });
      if (!success) { return; }
      this.transFileTaskCountNum = result;
    },
    tipCancel () {
      this.tipVisible = false;
    },
    handleSizeChange (val) {
      this.loading = true;
      this.query.rows = val;
      this.getTaskList();
    },
    handleCurrentChange (val) {
      this.loading = true;
      this.query.page = val;
      this.getTaskList();
    },
    handleSelectionChange (selection) {
      this.selTaskList = [];
      selection.forEach(item => {
        this.selTaskList.push({
          id: item.id,
          userId: item.userId,
          finish: item.finish,
        });
      });
    },
    downloadHide () {
      this.downloadStr = '';
    },
    async downloadReport (type, row) {
      let id = row.id;
      this.$refs[`popover-${id}`].doClose();
      let downType = null;
      let downloadArr = {
        'translate-translation': [1, 3, 11],
        'translate-contrast': [2, 4, 12],
      }
      switch (type) {
        case 'original':
          downType = 6;
          break;
        case 'translate-translation':
          downType = downloadArr[type][this.taskType - 1];
          break;
        case 'translate-contrast':
          downType = downloadArr[type][this.taskType - 1];
          break;
        case 'XLFreport':
          downType = 10;
          break;
      }
      let { result, success } = await downloadAsyncTask({
        splitRowsReqVo: {
          end: row.endRow,
          start: row.startRow
        },
        fileId: this.activeFile.id,
        versionType: this.taskType,
        downType,
      });
      if (!success) {
        return;
      }
      if (result.percent == 100) {
        this.downloadServerFile(result.fileName, result.downloadUrl)
      } else {
        this.isDownloadLoading = true;
        this.getDownloadAsyncResult(result.taskKey);
      }
    },
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getDownloadAsyncResult (taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
      }, 2000);
    }
  },
  watch: {
    taskType: {
      handler (newVal) {
        this.query.filter.taskType = newVal;
        this.selObj.taskType = newVal;
      },
      deep: true,
    },
    query: {
      handler () {
        this.loading = true;
        this.getTaskList();
        this.getTransFileTaskCountNum();
      },
      deep: true,
    },
    activeFile: {
      handler (newVal) {
        if (JSON.stringify(newVal) === '{}') {
          return;
        }
        this.query.filter.fileId = newVal.id;
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
  @import './assets/style.less';
</style>
<style lang="less">
@media screen and (max-width: 1260px) {
  .task-list {
    .el-progress-bar {
      display: none;
    }
    .el-progress__text {
      margin: 0;
    }
  }
}
.task-download {
  padding: 0;
  .el-cascader-menu {
    min-width: 130px;
    height: 140px;
  }
  ul {
    li {
      height: 32px;
      .el-icon-check {
        display: none;
      }
      .el-cascader-node__label {
        line-height: 32px;
      }
    }
  }
}
#downloadLoadingBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  z-index: 1000;
  text-align: center;

  .loadingMain {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
    i {
      font-size: 30px;
    }
  }
}
</style>